import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { ProjectMembers } from "./ui";

export const ProjectMembersRoute = (...rest: RouteObject[]): RouteObject => {
  return {
    path: `${routes.general.members()}`,
    element: createElement(ProjectMembers),
    children: [...rest],
  };
};
